import { Box, Typography } from '@mui/material'
import React from 'react'
import { RevealWrapper } from 'next-reveal'

const Intro = () => {
    return (
        <div>
            <Box className='container overflow-hidden'>
                <RevealWrapper origin='left' delay={200} duration={1000} distance='500px' reset={true} viewOffset={{ top: 25, right: 0, bottom: 10, left: 5 }}>
                    <Typography variant='h4' sx={{ color: "#31F711" }}>Introduction</Typography>
                </RevealWrapper>

                <RevealWrapper origin='right' delay={200} duration={1000} distance='500px' reset={false} viewOffset={{ top: 25, right: 0, bottom: 10, left: 5 }}>
                    <Typography className='para_main mt-3' variant='h6' sx={{ fontFamily: "-moz-initial", textIndent: 15, }} >
                        I am a <span style={{ color: "#31F711", fontWeight: "bold" }}> MERN Stack & Mobile App Developer </span> having <span style={{ color: "#31F711", fontWeight: "bold" }}> 3+ Years of Experience </span>. My proficient skills are in <span style={{ color: "#31F711", fontWeight: "bold" }}> React Js, React Native (Mobile App Development) </span>, <span style={{ color: "#31F711", fontWeight: "bold" }}> Nest Js, Express Js </span>, and <span style={{ color: "#31F711", fontWeight: "bold" }}> Node Js </span>. I specialize in building high-quality user interfaces (UI) for websites, mobile applications, and software. Additionally, I have strong problem-solving skills and a passion for clean code.
                    </Typography>
                </RevealWrapper>

            </Box>
        </div >
    )
}

export default Intro
